import React from 'react';
import { Mail, Phone, Instagram } from 'lucide-react';
import { brand } from '../mock';
import Reveal from './Reveal';
import Logo from './Logo';

const footerServices = ['Estimating & takeoffs', 'Bill of quantities', 'Tender pricing', 'Cost planning', 'Material schedules', 'Labour & plant'];

const CtaFooter = () => {
  return (
    <>
      {/* CTA */}
      <section id="contact" className="bg-[#262629] px-5 md:px-10 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto text-center">
          <Reveal>
            <h2 className="font-display text-yellow text-5xl md:text-7xl lg:text-8xl mb-10">
              Ready to price<br />your next project?
            </h2>
            <a
              href="/contact"
              className="inline-block bg-jaw-yellow text-[#262629] font-semibold text-lg px-10 py-5 rounded-[10px] hover:bg-[#e8660a] transition-colors"
            >
              Speak to our experts
            </a>
          </Reveal>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a1a1c] px-5 md:px-10 pt-16 pb-10">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
            <div>
              <Logo className="h-11 mb-6" />
              <p className="text-white/60 text-sm leading-relaxed max-w-xs">
                Fast, accurate construction estimating and takeoff services for builders across the UK.
              </p>
            </div>
            <div>
              <h5 className="font-display text-white text-lg mb-4">Services</h5>
              <ul className="space-y-2.5">
                {footerServices.map((d) => (
                  <li key={d}>
                    <a href="/#hire" className="text-white/60 hover:text-yellow text-sm transition-colors">{d}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h5 className="font-display text-white text-lg mb-4">Company</h5>
              <ul className="space-y-2.5">
                {[
                  { label: 'Services', href: '/#hire' },
                  { label: 'Reviews', href: '/reviews' },
                  { label: 'Our reports', href: '/reports' },
                  { label: 'FAQs', href: '/#faqs' },
                  { label: 'Contact', href: '/contact' },
                ].map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-white/60 hover:text-yellow text-sm transition-colors">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h5 className="font-display text-white text-lg mb-4">Get in touch</h5>
              <a href={`mailto:${brand.email}`} className="flex items-center gap-2 text-white/60 hover:text-yellow text-sm mb-3 transition-colors">
                <Mail className="w-4 h-4" />{brand.email}
              </a>
              <a href={brand.phoneHref} className="flex items-center gap-2 text-white/60 hover:text-yellow text-sm mb-5 transition-colors">
                <Phone className="w-4 h-4" />{brand.phone}
              </a>
              <a href="https://www.instagram.com/coreestimating" target="_blank" rel="noopener noreferrer" className="inline-flex w-10 h-10 rounded-full bg-white/10 items-center justify-center text-white hover:bg-jaw-yellow hover:text-[#262629] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
          <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">© {new Date().getFullYear()} Core Estimating. All rights reserved.</p>
            <p className="text-white/40 text-sm">Plymouth, United Kingdom</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default CtaFooter;
